import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { assignDefinedFields } from '../../utils/assign-fields';
import { assignMetadata } from '../../utils/assign-metadata';
import {
  createKeyphraseBoosting,
  deleteKeyphraseBoosting,
  updateKeyphraseBoosting,
} from './actions';
import type { KeyphraseBoosting, Keyphrases } from './types';

export const keyphraseBoostingAdapter =
  createEntityAdapter<KeyphraseBoosting>();

export const keyphraseBoostingSelectors =
  keyphraseBoostingAdapter.getSelectors();

const initialState: Keyphrases = {
  keyphraseBoosting: keyphraseBoostingAdapter.getInitialState(),
};

const slice = createSlice({
  name: 'keyphraseBoosting',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(createKeyphraseBoosting, (state, action) => {
      const entity: KeyphraseBoosting = {
        ...action.payload,
        createdAt: '',
        createdBy: '',
        updatedAt: '',
        updatedBy: '',
      };

      assignMetadata(action, entity);
      keyphraseBoostingAdapter.addOne(state.keyphraseBoosting, entity);
    });

    builder.addCase(updateKeyphraseBoosting, (state, action) => {
      const keyphrase = keyphraseBoostingSelectors.selectById(
        state.keyphraseBoosting,
        action.payload.id,
      );

      if (!keyphrase) {
        return;
      }

      const toUpdate = { ...keyphrase };
      assignDefinedFields(toUpdate, action.payload);
      assignMetadata(action, toUpdate);

      keyphraseBoostingAdapter.updateOne(state.keyphraseBoosting, {
        id: action.payload.id,
        changes: toUpdate,
      });
    });

    builder.addCase(deleteKeyphraseBoosting, (state, action) => {
      keyphraseBoostingAdapter.removeOne(
        state.keyphraseBoosting,
        action.payload.id,
      );
    });
  },
});

export default slice.reducer;
